import { render, staticRenderFns } from "./software.vue?vue&type=template&id=801be832&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"
import style0 from "./software.vue?vue&type=style&index=0&id=801be832&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801be832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('801be832')) {
      api.createRecord('801be832', component.options)
    } else {
      api.reload('801be832', component.options)
    }
    module.hot.accept("./software.vue?vue&type=template&id=801be832&scoped=true", function () {
      api.rerender('801be832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/software.vue"
export default component.exports